import React, { useEffect, useState } from "react";
import VerifyNumberAbha from "../abhanumber-details/verify-number-abha";
import { AlreadyAbhaVerifyAddress, EncryptDataABDM } from "../../services";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setResentCount } from "../../redux/slices/abhaSlice";

const VerifyAbhaAddress = ({
  inputValue,
  setResMessage,
  resMessage,
  handleBack,
}) => {
  const [verifyNumberAbha, setVerifyNumberAbha] = useState(false);
  const [consent, setConsent] = useState(false);
  const [authMethod, setAuthMethod] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [abhaDetails, setAbhaDetails] = useState(null);
  const [selectedAbha, setSelectedAbha] = useState(null);

  const resendCount = useSelector((state) => state.user.resentCount);
  const dispatch = useDispatch();

  useEffect(() => {
    const storedAbhaDetails = localStorage.getItem("abhaDetails");
    if (storedAbhaDetails) {
      try {
        const parsed = JSON.parse(storedAbhaDetails);

        if (parsed.data || parsed.abha) {
          const source = parsed.data || parsed.abha;

          setAbhaDetails({
            abha: {
              name: source.fullName || source.name,
              ABHANumber: source.healthIdNumber || source.ABHANumber,
              abhaAddress: source.abhaAddress,
              gender: source.gender || "N/A",
              kycVerified: source.kycVerified || false,
            },
            inputValue: source.mobile || parsed.inputValue,
          });
        } else {
          setAbhaDetails(parsed);
        }
      } catch (err) {
        console.error("Invalid ABHA details in localStorage", err);
      }
    }
  }, []);

  const getAbhaList = () => {
    if (!abhaDetails) return [];
    if (Array.isArray(abhaDetails.abha)) return abhaDetails.abha;
    if (typeof abhaDetails.abha === "object") return [abhaDetails.abha];
    return [];
  };

  const handleCardSelect = (item) => {
    setSelectedAbha(item);
  };

  const handleVerifyNumberAbha = async (e) => {
    e.preventDefault();

    if (!consent) {
      toast.error("Please accept the consent checkbox.");
      return;
    }

    if (!authMethod) {
      toast.error("Please select an authentication method (Mobile / Aadhaar).");
      return;
    }

    if (!abhaDetails) {
      toast.error("No ABHA details found.");
      return;
    }

    if (!selectedAbha) {
      toast.error("Please select an ABHA card.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const encryptedInput = await EncryptDataABDM({ body: inputValue });

      let requestData = {};
      if (authMethod === "mobile") {
        requestData = {
          scope: ["abha-address-login", "mobile-verify"],
          loginHint: "abha-address",
          loginId: encryptedInput.data,
          otpSystem: "abdm",
          resent_count: resendCount,
        };
      } else if (authMethod === "aadhaar") {
        requestData = {
          scope: ["abha-address-login", "aadhaar-verify"],
          loginHint: "abha-address",
          loginId: encryptedInput.data,
          otpSystem: "aadhaar",
          abhaNumber: selectedAbha?.ABHANumber || abhaDetails?.abha?.ABHANumber,
          resent_count: resendCount,
        };
      }

      const response = await AlreadyAbhaVerifyAddress({
        headers: {},
        data: requestData,
      });

      if (response?.resent_count !== undefined) {
        dispatch(setResentCount(response.resent_count));
      }

      if (response.success === false) {
        toast.error(response.message || "Failed to send OTP");
        return;
      }
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        // setsendOtpResponse(true);
        setResMessage(response.message);
        setVerifyNumberAbha(true);
      }
    } catch (err) {
      console.error(err);
      toast.error(
        err.message || "Something went wrong. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  const abhaList = getAbhaList();

  return (
    <>
      {verifyNumberAbha ? (
        <VerifyNumberAbha
          inputType="abhaaddress"
          otpType={authMethod}
          inputValue={inputValue}
          initialResentCount={resendCount}
          handleBack={() => setVerifyNumberAbha(false)}
          setResMessage={setResMessage}
          resMessage={resMessage}
        />
      ) : (
        <div className="col-md-6">
          <div className="form-card content">
            <h3 className="custom-h3">ABHA Number / ABHA Address</h3>
            <hr />

            <div className="abha-scroll-container">
              {abhaList.length > 0 ? (
                abhaList.map((item, idx) => (
                  <div
                    key={idx}
                    className={`abha-details-card ${
                      selectedAbha?.ABHANumber === item.ABHANumber
                        ? "selected-card"
                        : ""
                    }`}
                    onClick={() => handleCardSelect(item)}
                  >
                    <p>
                      <strong>Name:</strong> {item.name}
                    </p>
                    <p>
                      <strong>ABHA Number:</strong>{" "}
                      {`xx-xxxx-xxxx-${item.ABHANumber?.slice(-4)}`}
                    </p>
                    <p>
                      <strong>ABHA Address:</strong> {item.abhaAddress}
                    </p>
                  </div>
                ))
              ) : (
                <p>No ABHA records found.</p>
              )}
            </div>

            <div className="checkbox-group">
              <label className="abha-agree-text">
                <input
                  type="checkbox"
                  autoComplete="off"
                  checked={consent}
                  onChange={() => setConsent((v) => !v)}
                />{" "}
                I agree to give my consent to Pathkind Labs to link and update
                my details as per ABHA Address
              </label>
            </div>

            <p className="auth-method-title">Choose Authentication Method</p>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="auth"
                  value="mobile"
                  autoComplete="off"
                  checked={authMethod === "mobile"}
                  onChange={(e) => setAuthMethod(e.target.value)}
                />{" "}
                Verify via Mobile OTP
              </label>
              <label>
                <input
                  type="radio"
                  autoComplete="off"
                  name="auth"
                  value="aadhaar"
                  checked={authMethod === "aadhaar"}
                  onChange={(e) => setAuthMethod(e.target.value)}
                />{" "}
                Verify via Aadhaar OTP
              </label>
            </div>

            {error && (
              <div className="text-danger pt-2" style={{ fontSize: "14px" }}>
                {error}
              </div>
            )}

            <div className="d-flex gap-2">
              <button className="btn-back2" onClick={handleBack}>
                Back
              </button>
              <button
                className={`continue-btn nha-adhar continue-btn custom-btnmargin ${
                  !consent ? "bg-disable" : ""
                }`}
                onClick={handleVerifyNumberAbha}
                disabled={!consent || loading}
              >
                {loading ? "Linking..." : "Link Now"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VerifyAbhaAddress;
